import {h, Fragment} from "preact"
import { useFacets, useAppState, useProductFilters } from "@nosto/preact"
import { useEffect, useRef, useState } from "preact/hooks"
import { filtersOrder } from "../config"
import SelectedFilters from './SelectedFilters'
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
    const { response: { products } } = useAppState();
    const { loading, facets } = useFacets();
    const { removeAll, filters } = useProductFilters();
    
    const headerRef = useRef(null);
    const [ headerHeight, setHeaderHeight ] = useState(0);
    const footerRef = useRef(null);
    const [ footerHeight, setFooterHeight ] = useState(0);

    useEffect(() => {
        if(headerRef.current) {
            setHeaderHeight(headerRef.current.clientHeight)
        }
    }, [headerRef, filters])

    useEffect(() => {
        if(footerRef.current) {
            setFooterHeight(footerRef.current.clientHeight);
        }
    }, [])

    return facets?.length > 0 ? (
        <>
            <div
                id="ns-filters-sidebar"
                aria-expanded={sidebarOpen}
                aria-label="filter options"
            >
                <div class="ns-sidebar-content" style={`--header-height: ${headerHeight}px; --footer-height: ${footerHeight}px`}>
                    <div class="ns-sidebar-header" ref={headerRef}>
                        <div class="ns-sidebar-heading">
                            <span class="ns-sidebar-header-text">Filter</span>
                            {filters.length > 0 && 
                                <button 
                                    type="button"
                                    class="ns-sidebar-header-clear-filters"
                                    onClick={removeAll}
                                >
                                    Clear All
                                </button>
                            }
                        </div>
                        <SelectedFilters isInSidebar = {true} />
                        <button type="button" class="ns-sidebar-header-close-btn" onClick={toggleSidebar}>
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="16px" viewBox="0 0 16 16" version="1.1">
                                <g id="B2---PLP-&amp;-Filter/Sort" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g id="PLP---Mobile-Filter-State" transform="translate(-1122.000000, -1211.000000)" stroke="#000000" stroke-width="2"><g id="Group-Copy" transform="translate(1123.000000, 1212.000000)"><line x1="0" y1="0" x2="14" y2="14" id="Path"/><line x1="0" y1="14" x2="14" y2="0" id="Path"/></g></g></g>
                            </svg>
                        </button>
                    </div>

                    <div class="ns-sidebar-body">
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                            {facets?.map(facet => {
                                if(facet.data?.length < 2) return;
                                if(filtersOrder[facet.name]) {
                                    facet.data.sort((a, b) => {
                                        const indexA = filtersOrder[facet.name].indexOf(a.value);
                                        const indexB = filtersOrder[facet.name].indexOf(b.value);
                                        if (indexA === -1) return 1;
                                        if (indexB === -1) return -1;
                                        return indexA - indexB;
                                    });
                                }
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet facet={facet} />
                                    case "stats":
                                        return <RangeFacet facet={facet} />
                                }
                            })}
                        </ul>
                    </div>

                    <div class="ns-sidebar-footer" ref={footerRef}>
                        <button 
                            type="button" 
                            class="ns-view-results-btn"
                            onClick={toggleSidebar}
                        >
                            View Results ({products.total})
                        </button>
                    </div>
                </div>
            </div>
            <div 
                class="ns-sidebar-backdrop" 
                aria-label="close filters sidebar"
                role="button"
                tabindex="0"
                onClick={toggleSidebar}
            ></div>
        </>
    ) : ( null )
}
